import { ccEvent } from '@/api/app'

export const ccLog = (token: string) => {
  const userAgent = navigator.userAgent
  ccEvent({ device_info: userAgent }, token)
}